export const PLATFORM_SERVERS = {
    youtube: [
        { label: 'Primary', url: 'rtmps://a.rtmps.youtube.com/live2' },
        { label: 'Backup', url: 'rtmps://b.rtmps.youtube.com/live2' },
    ],
    twitch: [
        {
            label: 'Auto',
            url: 'rtmps://ingest.global-contribute.live-video.net/app',
        },
        {
            label: 'EU: Stockholm',
            url: 'rtmps://eun10.contribute.live-video.net/app',
        },
        {
            label: 'EU: Frankfurt',
            url: 'rtmps://euc10.contribute.live-video.net/app',
        },
        {
            label: 'EU: Paris',
            url: 'rtmps://euw30.contribute.live-video.net/app',
        },
        {
            label: 'EU: Ireland',
            url: 'rtmps://euw10.contribute.live-video.net/app',
        },
        {
            label: 'US East: N. Virginia',
            url: 'rtmps://use10.contribute.live-video.net/app',
        },
        {
            label: 'US East: Ohio',
            url: 'rtmps://use20.contribute.live-video.net/app',
        },
        {
            label: 'US West: Oregon',
            url: 'rtmps://usw20.contribute.live-video.net/app',
        },
        {
            label: 'Asia: Tokyo',
            url: 'rtmps://apn10.contribute.live-video.net/app',
        },
        {
            label: 'Asia: Seoul',
            url: 'rtmps://apn20.contribute.live-video.net/app',
        },
        {
            label: 'Asia: Singapore',
            url: 'rtmps://aps10.contribute.live-video.net/app',
        },
        {
            label: 'Asia: Mumbai',
            url: 'rtmps://aps30.contribute.live-video.net/app',
        },
        {
            label: 'Asia: Sydney',
            url: 'rtmps://aps20.contribute.live-video.net/app',
        },
        {
            label: 'South America: São Paulo',
            url: 'rtmps://sae10.contribute.live-video.net/app',
        },
    ],
    linkedin: [],
    x: [],
};
